// P4 — learning streaks (Document 11 §P4). A streak is driven by meaningful
// learning activity only (episode completion, quiz attempts, practice
// scenarios, interactive stories, escape rooms) — never by merely opening
// the app. lastActivityDate is an ISO calendar date (YYYY-MM-DD, local to
// the browser), not a timestamp, so "did they do something today" is a
// simple string comparison.
export interface StreakRecord {
  userId: string
  currentStreak: number
  longestStreak: number
  lastActivityDate: string | null // YYYY-MM-DD
  updatedAt: string
}

// Streak lengths (in days) that count as a meaningful milestone worth an
// achievement — deliberately a short, curated list rather than "every day."
export const STREAK_MILESTONES = [3, 7, 14, 30]

export type StreakActivitySource =
  | 'episode_completed'
  | 'quiz_attempted'
  | 'scenario_completed'
  | 'story_completed'
  | 'escape_room_completed'
